import React, { useEffect, useState, useRef, useContext } from "react";

import GenderForm from "./components/genderForm";
import BirthdayForm from "./components/birthdayForm";
import EmailForm from "./components/emailForm";
import NameForm from "./components/nameForm";
import PasswordForm from "./components/passwordForm";
import PromoStep from "./components/promoStep";
import { createPortal } from "react-dom";
import PopUp from "./components/PopUp";
import { simplyClick } from "./helpers/index";
import { Footer } from "./components/Footer";
import { getTTI, sendScreenResolution } from "./helpers";
import { EVENTS_SIGN_IN, landingId } from "./constants";
import { useAppendLandingId } from "./hooks/useAppendLandingId";
import { ContextProfileUser } from "./lib/profileContext"
import modelOne from "./images/model1.png";
import modelTwo from "./images/model2.png";
import modelThree from "./images/model3.png";
import modelFour from "./images/model4.png";
import modeFive from "./images/model5.png";
import modelSix from "./images/model6.png";
import modelSeven from "./images/model7.png";
import { useSessionData } from "ui-components";

function App() {
  const [step, setStep] = useState(() => {
    const nav = performance.getEntriesByType("navigation")[0];
    const isReload = nav ? nav.type === "reload" : false;
    return isReload ? 1 : window.history.state?.step || 1;
  });

  const speedRef = useRef(0.5);

  const [showPopUp, setShowPopUp] = useState(false);
  const footer = document.getElementById("footer");
  let content = null;
  const { data, setData } = useContext(ContextProfileUser);
  const { getSessionData, saveSessionData } = useSessionData(landingId);

  useEffect(() => {
    const saved = getSessionData();
    if (saved) {
      setData(saved);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(data).length > 0) {
      saveSessionData(data);
    }
  }, [data, saveSessionData]);

  useAppendLandingId(landingId);

  useEffect(() => {
    const images = [
      modelOne,
      modelTwo,
      modelThree,
      modelFour,
      modeFive,
      modelSix,
      modelSeven,
    ];

    images.forEach((src) => {
      const img = new Image();
      img.src = src;
    });
  }, []);

  useEffect(() => {
    const handlePopState = (event) => {
      const newStep = event.state?.step;
      if (newStep) setStep(newStep);
    };

    const handlePageShow = (event) => {
      if (event.persisted) {
        const newStep = window.history.state?.step;
        if (newStep) setStep(newStep);
      }
    };

    window.addEventListener("popstate", handlePopState);
    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  useEffect(() => {
    const currentState = window.history.state;
    if (!currentState || currentState.step !== step) {
      window.history.replaceState({ ...currentState, step }, "");
    }
  }, [step]);

  useEffect(() => {
    const loader = document.getElementById("loader");
    if (loader) {
      loader.style.display = "none";
    }

    const handleFocus = (e) => {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
        document.body.classList.add("keyboard-open");
      }
    };

    const handleBlur = (e) => {
      if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
        setTimeout(() => {
          document.body.classList.remove("keyboard-open");
        }, 200);
      }
    };

    document.addEventListener("focusin", handleFocus);
    document.addEventListener("focusout", handleBlur);

    return () => {
      document.removeEventListener("focusin", handleFocus);
      document.removeEventListener("focusout", handleBlur);
    };
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
    const signInButton = document.querySelector(".sign-in");

    const handleClick = () => {
      const eventName = EVENTS_SIGN_IN[step - 1];
      if (eventName) {
        simplyClick(eventName);
      }
    };

    if (signInButton) {
      signInButton.addEventListener("click", handleClick);
    }

    return () => {
      if (signInButton) {
        signInButton.removeEventListener("click", handleClick);
      }
    };
  }, [step]);

  const openPopUp = (e) => {
    if (e.target === e.currentTarget) {
      setShowPopUp(true);
      simplyClick("cl_lnd_photos", { text: `step(${step})` });

    }
  };

  const closePopUp = () => {
    setShowPopUp(false);
  };

  useEffect(() => {
    let popupRoot = document.getElementById("popup-root");
    if (!popupRoot) {
      popupRoot = document.createElement("div");
      popupRoot.id = "popup-root";
      document.body.appendChild(popupRoot);
    }

    if (window.location.search !== "") {
      const signInButton = document.querySelector(".sign-in");
      if (signInButton) {
        signInButton.setAttribute("href", `/login/${window.location.search}`);
      }
    }

    const timer = setTimeout(() => {
      getTTI();
      sendScreenResolution();
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const registerGoogleContainer = document.querySelector(".content__wrapper");

    if (registerGoogleContainer && !showPopUp) {
      registerGoogleContainer.addEventListener("click", openPopUp);
    }

    return () => {
      if (registerGoogleContainer) {
        registerGoogleContainer.removeEventListener("click", openPopUp);
      }
    };
  }, [step, showPopUp]);

  useEffect(() => {
    speedRef.current = showPopUp ? 0.4 : 0.5;
  }, [showPopUp]);

  useEffect(() => {
    const wrapper = document.querySelector(".content__wrapper");
    if (!wrapper) return;
    let position = 0;
    let lastTimestamp = performance.now();
    let animationFrameId;
    const animateBg = (timestamp) => {
      const elapsed = timestamp - lastTimestamp;
      lastTimestamp = timestamp;
      position += speedRef.current * (elapsed / 16);
      wrapper.style.backgroundPosition = `${position}px 56px`;
      animationFrameId = requestAnimationFrame(animateBg);
    };
    animationFrameId = requestAnimationFrame(animateBg);
    return () => cancelAnimationFrame(animationFrameId);
  }, []);

  switch (step) {
    case 2:
      content = <GenderForm nextStep={() => setStep(3)} />;
      break;
    case 3:
      content = <BirthdayForm nextStep={() => setStep(4)} />;
      break;
    case 4:
      content = <NameForm nextStep={() => setStep(5)} />;
      break;
    case 5:
      content = <EmailForm nextStep={() => setStep(6)} />;
      break;
    case 6:
      content = <PasswordForm nextStep={() => setStep(7)} />;
      break;
    default:
      content = <PromoStep nextStep={() => setStep(2)} />;
      break;
  }

  return (
    <>
      {showPopUp &&
        createPortal(
          <PopUp step={step} closePopUp={closePopUp} />,
          document.getElementById("popup-root")
        )}
      {content}
      {footer && createPortal(<Footer step={step} />, footer)}
    </>
  );
}

export default App;
